import React, { useEffect, useRef, useState } from 'react';
import { SCAN_FLASH_EVENT, installAudioUnlock } from '../../utils/scanFeedback';
import './ScanFlash.css';

const FLASH_MS = 400;

// Coloured glow around the screen edge after a scan (green / red / amber), driven by
// scanFeedback(). Mount once, in App. With reduced motion it shows a static border.
const ScanFlash = () => {
  const [flash, setFlash] = useState(null);
  const timerRef = useRef(null);

  useEffect(() => {
    installAudioUnlock();
    let seq = 0;
    const handleFlash = (e) => {
      seq += 1;
      setFlash({ kind: e.detail?.kind || 'success', seq });
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setFlash(null), FLASH_MS);
    };
    window.addEventListener(SCAN_FLASH_EVENT, handleFlash);
    return () => {
      window.removeEventListener(SCAN_FLASH_EVENT, handleFlash);
      clearTimeout(timerRef.current);
    };
  }, []);

  if (!flash) return null;
  // Keyed by seq so back-to-back scans restart the animation
  return <div key={flash.seq} className={`scan-flash scan-flash-${flash.kind}`} aria-hidden="true" />;
};

export default ScanFlash;
